import React from 'react';

const ModalVideos = ({ isOpen, onClick }) => {
  if (!isOpen) return null;

  return (
    <div style={overlayStyle} onClick={onClick}>
      <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
        <button onClick={onClick} style={closeBtnStyle}>×</button>
        <iframe
          width="100%"
          height="400"
          src="https://www.youtube.com/embed/Faow3SKIzq0?autoplay=1"
          title="YouTube Video"
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.75)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000,
};

const modalStyle = {
  background: '#000',
  padding: '1rem',
  borderRadius: '8px',
  maxWidth: '90%',
  maxHeight: '80%',
  position: 'relative',
};

const closeBtnStyle = {
  position: 'absolute',
  top: '-12px',
  right: '-12px',
  background: '#fff',
  color: '#000',
  border: 'none',
  fontSize: '1.5rem',
  borderRadius: '50%',
  width: '32px',
  height: '32px',
  cursor: 'pointer',
};

export default ModalVideos;
